var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegisterSolid = function SvgRegisterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.766 1.643A1 1 0 1 0 14.234.357l-.913 1.089C12.346 1 10.894 1 8.519 1H7.481c-3.055 0-4.583 0-5.532.95C1 2.897 1 4.425 1 7.48v1.038c0 3.055 0 4.583.95 5.532C2.897 15 4.425 15 7.48 15h1.038c3.055 0 4.583 0 5.532-.95C15 13.103 15 11.575 15 8.52V7.481c0-2.16 0-3.557-.335-4.525l1.101-1.313Zm-1.101 1.313a2.568 2.568 0 0 0-.614-1.007 2.463 2.463 0 0 0-.73-.503L8.258 7.483l-1.52-1.659a1 1 0 1 0-1.475 1.352l2.29 2.5a1 1 0 0 0 1.504-.033l5.608-6.687Z",
    clipRule: "evenodd"
  })));
};
export default SvgRegisterSolid;